import Owl from '@dp/owl';
import { isProd } from '@/config/';
Owl && Owl.start({
  project: 'com.sankuai.movie.showf2e.mmh5',
  // 数据上报的项目名称, 与在 Raptor 上申请的保持一致
  devMode: !isProd ? true : false,
  // 用于区分数据上报的环境
  pageUrl: 'Home',
  // 数据上报对应的url
  page: {
    fstPerfAnalysis: true,
    //1.8.13 支持，首屏慢访分析，首屏性能指标的解析和上报（不是必须可以不配置）
    delay: 2000,
    //延迟性能上报请求，合并上报（不是必须可以不配置）
    logSlowView: true
  },
  resource: {
    ignoreMTSIForbidRequest: false,
    sampleApi: 0.5,
    enableStatusCheck: true // 采集准确的请求 HTTP 状态码
  },

  enableLogTrace: true,
  // 开启请求链路日志功能
  error: {
    formatUnhandledRejection: true // 格式化 unhandledrejection 类型异常
  },

  autoCatch: {
    ajax: false,
    console: true
  },
  ignoreList: {
    js: [
    // 已知无影响的异常
    'Illegal invocation', 'ResizeObserver loop limit exceeded'],
    ajax: [
    // 与业务无关的请求
    'https?://api.neixin.cn/dxlvs/open/v2/lgservers/json']
  }
});
export default function owlConfig(name) {
  name && Owl.config({
    pageUrl: name // 数据上报对应的name
  });
}